import { Button, Collapse, Select } from "antd"
import { Controller, UseFormReturn } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { IEditAccidentForm } from "."
import TextArea from "antd/es/input/TextArea"
import { BaseSyntheticEvent } from "react"
import { useAccidentNatures } from "../queries"
import { FormControl } from "@atoms"
interface Props {
  form: UseFormReturn<IEditAccidentForm>
  onSubmit: (
    e?: BaseSyntheticEvent<object, any, any> | undefined
  ) => Promise<void>
  submitIsLoading: boolean
}

const Precision: React.FC<Props> = ({
  form: { control },
  onSubmit,
  submitIsLoading,
}) => {
  const { t } = useTranslation()
  const accidentsNature = useAccidentNatures()
  return (
    <Collapse
      accordion
      items={[
        {
          id: "accident_nature",
          label: t("accidents.accident_nature"),
          children: (
            <div>
              <FormControl>
                <Controller
                  control={control}
                  name="nature"
                  render={({ field }) => (
                    <Select
                      loading={accidentsNature.isLoading}
                      options={accidentsNature.data?.map((item) => ({
                        value: item.value,
                        label: item.label,
                      }))}
                      showSearch
                      placeholder={t("accidents.accident_nature")}
                      {...field}
                    />
                  )}
                />
              </FormControl>
              <Button
                loading={submitIsLoading}
                type="primary"
                onClick={onSubmit}
              >
                {t("global.save")}
              </Button>
            </div>
          ),
        },
        {
          id: "situation_cause_consequence",
          label: t("accidents.situation_cause_consequence"),
          children: (
            <>
              <FormControl>
                <Controller
                  control={control}
                  name="situation"
                  render={({ field }) => (
                    <TextArea
                      {...field}
                      placeholder={t("accidents.situation_cause_consequence")}
                    />
                  )}
                />
              </FormControl>
              <Button
                loading={submitIsLoading}
                type="primary"
                onClick={onSubmit}
              >
                {t("global.save")}
              </Button>
            </>
          ),
        },
        {
          id: "interventions_performed",
          label: t("accidents.interventions_performed"),
          children: (
            <>
              <FormControl>
                <Controller
                  control={control}
                  name="intervention"
                  render={({ field }) => (
                    <TextArea
                      {...field}
                      placeholder={t("accidents.interventions_performed")}
                    />
                  )}
                />
              </FormControl>
              <Button
                loading={submitIsLoading}
                type="primary"
                onClick={onSubmit}
              >
                {t("global.save")}
              </Button>
            </>
          ),
        },
        {
          id: "recommendations_followups",
          label: t("accidents.recommendations_followups"),
          children: (
            <>
              <FormControl>
                <Controller
                  control={control}
                  name="recommendation"
                  render={({ field }) => (
                    <TextArea
                      {...field}
                      placeholder={t("accidents.recommendations_followups")}
                    />
                  )}
                />
              </FormControl>
              <Button
                loading={submitIsLoading}
                type="primary"
                onClick={onSubmit}
              >
                {t("global.save")}
              </Button>
            </>
          ),
        },
        {
          id: "additional_informations",
          label: t("accidents.additional_informations"),
          children: (
            <>
              <FormControl>
                <Controller
                  control={control}
                  name="information"
                  render={({ field }) => (
                    <TextArea
                      {...field}
                      placeholder={t("accidents.additional_informations")}
                    />
                  )}
                />
              </FormControl>
              <Button
                loading={submitIsLoading}
                type="primary"
                onClick={onSubmit}
              >
                {t("global.save")}
              </Button>
            </>
          ),
        },
      ]}
    />
  )
}

export default Precision
